import { Box, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

export const PasswordFieldStack = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-200'),
  width: '100%',
}));
